<template>
  <div v-if="up" class="circle" :class="clickedYes ? 'positive' : ''">
    <svg :class="clickedYes ? 'bounce' : ''" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" fill="none">
      <g clip-path="url(#a)" :fill="color">
        <path
          d="M45.919 41.687V25.764a1.016 1.016 0 0 0-1.015-1.016H40.94a1.015 1.015 0 0 0-1.015 1.015v15.924a1.016 1.016 0 0 0 1.015 1.015h3.963a1.016 1.016 0 0 0 1.015-1.015Zm-31.371-10.7a2.455 2.455 0 0 0 1.637 2.218 3.168 3.168 0 0 0-1.056 2.235 2.326 2.326 0 0 0 1.948 2.276 3.275 3.275 0 0 0-1.13 2.161 3.062 3.062 0 0 0 2.972 3.037H33.95a3.004 3.004 0 0 0 2.996-2.996v-14.94a2.946 2.946 0 0 0-.9-2.088l-8.948-8.94a1.555 1.555 0 0 0-1.687-.254c-.27.221-.9.819-.9.819a1.728 1.728 0 0 0-.598 1.637c.03.413.087.823.172 1.228l1.326 6.1h-8.268a2.834 2.834 0 0 0-3.062 2.767 2.456 2.456 0 0 0 1.637 2.513 3.274 3.274 0 0 0-1.17 2.227Z" />
      </g>
      <defs>
        <clipPath id="a"><path fill="#fff" transform="rotate(-180 30 30)" d="M0 0h60v60H0z" /></clipPath>
      </defs>
    </svg>
  </div>

  <div v-if="!up" class="circle" :class="clickedNo ? 'negative' : ''">
    <svg :class="clickedNo ? 'bounce' : ''" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" fill="none">
      <g clip-path="url(#a)" :fill="color">
        <path
          d="M14.081 18.313v15.924a1.016 1.016 0 0 0 1.015 1.015h3.962a1.015 1.015 0 0 0 1.016-1.016V18.313a1.016 1.016 0 0 0-1.016-1.015h-3.962a1.016 1.016 0 0 0-1.015 1.015Zm31.371 10.7a2.455 2.455 0 0 0-1.637-2.218 3.168 3.168 0 0 0 1.056-2.235 2.326 2.326 0 0 0-1.948-2.276 3.275 3.275 0 0 0 1.13-2.161 3.062 3.062 0 0 0-2.972-3.038H26.05a3.005 3.005 0 0 0-2.996 2.997v14.94a2.946 2.946 0 0 0 .9 2.088l8.948 8.94a1.555 1.555 0 0 0 1.687.254c.27-.221.9-.819.9-.819a1.728 1.728 0 0 0 .598-1.637 9.01 9.01 0 0 0-.172-1.228l-1.326-6.1h8.268a2.834 2.834 0 0 0 3.062-2.767 2.456 2.456 0 0 0-1.637-2.513 3.274 3.274 0 0 0 1.17-2.227Z" />
      </g>
      <defs>
        <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ellevio-web-thumb',
  props: {
    color: {
      type: String,
      default: '#000'
    },
    up: {
      type: Boolean,
      default: false
    },
    clickedYes: {
      type: Boolean,
      default: false
    },
    clickedNo: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
@keyframes bounce {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
}

.bounce {
  animation: bounce 0.3s ease;
}

svg {
  position: relative;
  width: 3.375rem;
  height: 3.375rem;
  border-radius: 50%;
}

.circle {
  border-radius: 50%;
  border: 0.1875rem solid #2c2827;
  transition: transform 0.1s ease-in, border-color 0.2s ease-in;
}

.circle:hover {
  transform: scale(1.1);
}

.positive {
  border-color: #10a76b;
}
.negative {
  border-color: #ce1f36;
}
</style>
